<template>
  <div>
    <!-- BOC:[header] -->
    <v-row class="mb-3">
      <v-col class="text-right">
        <v-btn
          color="primary"
          large
          :to="{name:'PageModeratorEventEventFinisherGiftSent',params:{parentId:parent.id,parent:parent}}"
        >
        Sent Gift
        </v-btn>
        <v-btn
        class="ml-2"
          color="primary"
          large
          :to="{name:'PageModeratorEventEventFinisherList',params:{parentId:parent.id,parent:parent}}"
        >
        Generate List
        </v-btn>
      </v-col>
    </v-row>
    <!-- EOC -->
    <!-- BOC:[table] -->
    <BreadBrowseTable
      role="Moderator"
      :model="model"
      :url="`${$api.servers.event}/api/v2/en/moderator/event/${parent.id}/finisher`"
      :isSearchable="true"
      :parent="parent"
      :modelParent="modelParent"
    ></BreadBrowseTable>
    <!-- EOC -->
  </div>
  </template>
  
  <script>
    //BOC:[model]
    import modelParent from '@/models/items/event'
    import model from '@/models/items/eventFinisher'
    //EOC
    //BOC:[table]
    import BreadBrowseTable from '@/components/Bread/BreadBrowseTableV2'
    //EOC
    import { mapState } from 'vuex'
    export default {
      components:{
        //BOC:[table]
        BreadBrowseTable,
        //EOC
      },
      computed: mapState({
        school: state => state.school.data,
      }),
      props:[
        'role',
        'parent',
      ],
      data:()=>({
        //BOC:[model]
        modelParent:modelParent,
        model: model,
        //EOC
      }),
      created() {
        //
      },
      mounted() {
        //
      },
      methods: {
        //
      }
    }
  </script>